import { AwaitResponse } from '@general/js/utils/MockUtils';
import AbstractClass from './SupportAbstractServices';

export default class SupportServices extends AbstractClass {
  static getContactUsReferenceData() {
    return AwaitResponse({
      contactUsAboutOptions: [
        {
          display: 'I’m interested in joining Defence Health',
          returnValue: 'Joining',
        },
        {
          display: 'I have feedback for Defence Health',
          returnValue: 'Feedback',
        },
        {
          display: 'I would like to make a complaint',
          returnValue: 'Complaint',
        },
        {
          display: 'Other',
          returnValue: 'OtherPublic',
        },
      ],
      contactByOptions: [
        {
          display: 'Email',
          returnValue: 'Email',
        },
        {
          display: 'Phone',
          returnValue: 'Phone',
        },
      ],
    });
  }

  static postContactUsFeedback() {
    return AwaitResponse();
  }

  static getContactUsConfirmationRelatedArticles() {
    return AwaitResponse({
      relatedArticle1: {
        heading: 'How do I choose hospital cover?',
        toUrl: 'https://healthhq.defencehealth.com.au/2019/04/30/how-do-i-choose-hospital-cover/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/04/How-do-I-choose-hospital-cover-1024x683.jpg',
        imageAltText: 'family image',
        tag: 'Family',
        listedTime: '2021-09-08T10:25:26',
      },
      relatedArticle2: {
        heading: 'Keeping your cover affordable',
        toUrl: 'https://healthhq.defencehealth.com.au/2016/02/19/keeping-your-cover-affordable/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/02/Lady-on-Laptop-affordability-resized-1024x683.jpg',
        imageAltText: 'person on laptop',
        tag: 'Affordable',
        listedTime: '2021-09-08T10:25:27',
      },
      relatedArticle3: {
        heading: 'Make the most out of your health care',
        toUrl: 'https://healthhq.defencehealth.com.au/2016/08/31/make-health-care/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/08/Image-Benefits-of-PHI.jpg',
        imageAltText: 'hospital',
        tag: 'Wellness',
        listedTime: '2021-09-08T10:25:28',
      },
    });
  }
}
